module.exports = __webpack_public_path__ + "static/img/freelance-01.fd8cf0a5.png";